<template>
  <div class="head-bar-container" @click.self="closeMenu">
    <div class="head-bar-row pc_padding">
      <div class="head-bar-name-row cursor" @click="gohome">
        <div class="head-bar-name-icon">
          <img src="@/assets/Logo.svg" alt="">
        </div>
      </div>
      <div v-if="deviceType=='mobile'" class="head-bar-hamber-row cursor " @click="toggleOpenState">
        <img src="@/assets/menu.svg" alt="">
      </div>
      <div v-if="deviceType!='mobile'" class="head-bar-hamber-row  cursor ">
        <router-link to="/">
          <div class="head-bar-hamber-item" :class="{ active: $route.name == 'home' }">
            Overview
          </div>
        </router-link>
        <router-link to="/pricing">
          <div class="head-bar-hamber-item" :class="{ active: $route.name == 'pricing' }">
            Pricing
          </div>
        </router-link>
        <router-link to="/privacy">
          <div class="head-bar-hamber-item" :class="{ active: $route.name == 'privacy' }">
            Privacy
          </div>
        </router-link>
        <router-link to="/terms">
          <div class="head-bar-hamber-item" :class="{ active: $route.name == 'terms' }">
            Terms
          </div>
        </router-link>
      </div>
    </div>

    <div v-if="deviceType=='mobile'" class="menu" :class="{ 'menu-open': isOpen }">
      <div class="menu-open-head">
        <div class="menu-open-logo-row">
          <img src="@/assets/Logo.svg" class="logo" alt="">
          <img src="@/assets/Logo-long-w.svg" class="logo-long" alt="">
        </div>
        <img src="@/assets/close.png" class="close" alt="" @click="toggleOpenState">
      </div>
      <ul>
        <li class="cursor" @click="closeMenu">
          <router-link to="/">
            <div class="head-bar-hamber-item">
              Overview
            </div>
          </router-link>
        </li>
        <li class="cursor" @click="closeMenu">
          <router-link to="/pricing">
            <div class="head-bar-hamber-item">
              Pricing
            </div>
          </router-link>
        </li>
        <li class="cursor" @click="closeMenu">
          <router-link to="/privacy">
            <div class="head-bar-hamber-item">
              Privacy
            </div>
          </router-link>
        </li>
        <li class="cursor" @click="closeMenu">
          <router-link to="/terms">
            <div class="head-bar-hamber-item">
              Terms
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    deviceType: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      isOpen: false,
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    gohome () {
      this.$router.push('/')
    },
    toggleOpenState () {
      this.isOpen = !this.isOpen;
    },
    handleClickOutside (event) {
      if (this.isOpen && !this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    closeMenu () {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
  },
}
</script>
